import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import WebFont from 'webfontloader';
import './App.scss';
import { baseAppPath } from './config/GlobalConfig';
import ForgetPasswordEntreprisePage from './pages/entreprise/forget-password/ForgetPasswordEntreprisePage';
import InitPasswordEntreprisePage from './pages/entreprise/init-password/InitPasswordEntreprisePage';
import LoginEntreprisePage from './pages/entreprise/login/LoginEntreprisePage';

function App() {
  
  useEffect(() => {
    WebFont.load({
      custom: {
        families: ['Graphik', 'mgp-icons'],
        urls: [process.env.REACT_APP_RESSOURCE_BASE_URL + '/fonts/fonts.css']
      }
    });
   }, []);
  
  return (
    <section>
      <Routes>
        <Route path={baseAppPath} element={<LoginEntreprisePage />} />
        <Route path={baseAppPath + "/oublie-mot-passe"} element={<ForgetPasswordEntreprisePage />} />
        <Route path={baseAppPath + "/init-passe"} element={<InitPasswordEntreprisePage />} />
        <Route path="*" element={<Navigate to={baseAppPath} />}/>
      </Routes>
    </section>
    
  );
}

export default App;
